import { AxiosError } from 'axios';

export enum EResponseCode {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  PARAMETER_ERROR = 'PARAMETER_ERROR',
  NOT_FOUND = 'NOT_FOUND',
  IMPROPER_OPERATION = 'IMPROPER_OPERATION',
}

export interface IResponse<D, E = null> {
  code: EResponseCode;
  message?: string;
  data: D;
  extra: E;
}
export type IResponseError = AxiosError;

export type ICurrency = 'SGD' | 'HKD' | 'MYR' | 'IDR' | null;

export interface IBaseParams {
  offset?: number;
  limit?: number;
}

export interface ICreateParams {
  code?: string;
  message?: string;
  data?: any;
}

export interface IConfig {
  contractPDF: string;
  sampleAuthorizationLetter: string;
  platformName: string;
  currencies: string[];
  phoneAreaCodes: string[];
  template: any;
}

export interface IAddresses {
  id: string;
  name: string;
  children?: IAddresses[];
}
